<div class="modal1Main" *ngIf="infoData">
  <div class="modalHeader">
    <span class="title">
      League Preview
    </span>
    <button class="closepop float-right"  mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div class="fantasyGameHead" [ngStyle]="{'padding-bottom':infoData.buttons.length<=0?'10px':''}">
    <div class="row" style="display: flex;align-items: center;">
      <div class="headLeftPart">
        <h3 [ngStyle]="{'font-size':infoData.name.length>50?'14px':''}"><img src="{{assetURL}}/assets/default/images/{{ infoData?.league_type }}{{darkMode_ext}}.svg?v=2.7.5" alt="">{{infoData.name}}</h3>
      </div>
      <div class="headRightPart">
        <div [ngStyle]="{'text-align': 'right'}">
          <div class="" *ngIf="infoData.buttons">
            <span *ngFor="let button of infoData.buttons">
                <button *ngIf="button.type == 'Join';else unregister"  mat-raised-button color="primary" class="joinDraftBtn" (click)="joinLeaguePopup(infoData.league_code, button.speed)">Join <div *ngIf="button.sub_title && infoData.buttons.length > 1" class="sub-title">({{button.sub_title}})</div></button>
                <ng-template #unregister>
                  <button *ngIf="button.type == 'Unregister'" mat-raised-button color="danger" class="joinDraftBtn unregister" (click)="confirmDialog(infoData.league_code, button.speed, infoData.tournament_id)">Unregister <div *ngIf="button.sub_title && infoData.buttons.length > 1" class="sub-title">({{button.sub_title}})</div></button>
                </ng-template> 
            </span>
          </div>
          <span *ngIf="infoData.entries_full == 'YES'">
            <p [ngStyle]="{'color': 'red','float': 'right'}">Max entries is reached.</p>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="invite_PanelTab" style="min-height: 265px;">
    <mat-tab-group class="dtable panelContainer" (selectedTabChange)="tourTabChanged($event)">
      <mat-tab>
        <ng-template mat-tab-label class="tabLabel">
          <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
          Info
        </ng-template>
        <div >
          <perfect-scrollbar class="" [config]="config" [ngStyle]="{'max-height':screenHeightForModal[0]}" style=" max-width: 100%;">
            <div class="row">
              <div class="parent-info">
                <div class="col s12 m6 l6 xl6 lobbyInfoLeft lobbyInfo">
                  <h2>Contest Info</h2>
                  <perfect-scrollbar [config]="config" [ngStyle]="{'max-height':screenHeightForModal[1]}"  style="max-width: 100%; padding-bottom: 5px;">
                  <ul >
                    <li *ngFor="let record of infoData.info">
                      <span class="left">{{record.label}}: </span>
                      <span class="right" *ngIf="record.label == 'Buy-In';else scheduleInfo">${{ record.value.replace("$","") | number:'1.2-2' | Price }}</span>
                      <ng-template #scheduleInfo>
                        <span class="right" *ngIf="record.label == 'Schedule';else otherInfo">
                          {{record.value}}
                          <a class="schedule-info" (click)="scheduleInfoPopup()">{{record.attribute}}</a>
                        </span>
                        <ng-template #otherInfo>
                          <span class="right">{{(record.label == 'League Type')?record.value.toUpperCase():record.value}}</span> 
                        </ng-template>
                      </ng-template>
                    </li> 
                  </ul>
                </perfect-scrollbar>
                </div>
                <div class="col s12 m6 l6 xl6 lobbyInfoLeft lobbyInfo">
                  <h2>Prizes</h2>
                  <span class="jersey_img" *ngIf ="infoData.is_jersey">
                    <img src="{{infoData?.prize_img}}" alt="">
                  </span>  
                  <perfect-scrollbar *ngIf ="!infoData.is_jersey"  [config]="config" [ngStyle]="{'max-height':screenHeightForModal[1]}" style="max-width: 100%;">
                    <ul>
                      <li *ngFor="let prize of infoData.prize">
                        <span class="left">{{prize.rank}}: </span>
                        <span class=""><span class="pricespan"> ${{prize.amount | number:'1.2-2' | Price}}</span></span>
                      </li> 
                    </ul>
                  </perfect-scrollbar>
                </div>
              </div>
              <div class="row roundInfo" *ngIf="infoData.rounds.length>0">                
                
                        <a href="javascript:void(0)" (click)="showRounds= !showRounds"  class="col s12 m12 l12 xl12 roundInfoTitle"><i class="fas roundInfoIcon" [ngClass]="{'fa-plus':!showRounds,'fa-minus':showRounds}" ></i>&nbsp;<h2 style="display: inline-block;font-size: 16px !important;">Schedule</h2></a>                        
                              <perfect-scrollbar *ngIf="showRounds"  [config]="config" style="max-width: 100%;" [scrollIndicators]="true">
                                <ul>
                                  <li *ngFor="let round of infoData.rounds" (click)="scheduleInfoPopup(round.tour_league_id)">
                                    <p style="font-size: 14px;">{{round.round}}</p>
                                    <p style="font-size: 12px;">{{round.round_date}}--<a href="javascript:void(0);" class="schedule-info">{{round.event_text}}</a></p>
                                    <p style="font-size: 12px;">{{round.draft_text}}</p>
                                  </li> 
                                </ul>
                            </perfect-scrollbar>
                
              </div>
              
              <div class="clearfix"></div>
            </div>
          </perfect-scrollbar>
          <div class="row">
          <div class="col s6 m6 l6 xl6">
            <a href="{{siteUrl+'/'+'rules'}}" class="popuplink1">
              Site Rules & Scoring
            </a>
          </div>
          <div class="col s6 m6 l6 xl6">
            <a href="{{siteUrl+'/'+tournament+'/'+infoData.league_type+'/'+infoData.tournament_code}}" class="popuplink1 float-right">
              Go to League Home
            </a>
          </div>
        </div>
        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label class="tabLabel dtableCell">
          <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
          Roster & Scoring
        </ng-template>
        <div *ngIf="!scoringData"> 
          <h4 class="text-center">Loading...</h4> 
        </div>
        <div class="infoMain" *ngIf="scoringData">
          <div class="row">
            <div class="parent-info">
              <div class="col s12 m6 l6 xl6 infoIndiv">
                <h2>Roster Positions</h2>
                <perfect-scrollbar [config]="config" style="max-width: 100%; max-height: 265px;">
                  <ul>
                    <li *ngFor="let position of scoringData.roster_positions">{{position.display_name}} <span class="float-right">{{position.value}}</span></li> 
                  </ul>
                </perfect-scrollbar>
              </div>
              <div class="col s12 m6 l6 xl6 infoIndiv"> 
                  <h2>Scoring</h2>
                  <perfect-scrollbar [config]="config" style="max-width: 100%; max-height: 265px;"> 
                    <div *ngFor="let score of scoringData.scoring">
                      <h3 _ngcontent-c19="" *ngIf="score.label">{{score.label}}</h3>
                      <ul>
                        <li *ngFor="let rec of score.value">{{rec.display_name}} <span class="float-right">{{rec.value}}</span></li> 
                      </ul>
                    </div> 
                  </perfect-scrollbar>
              </div>
            </div>
          </div> 
        </div>
      </mat-tab>

      <mat-tab *ngIf="infoData.isMilestone">
        <ng-template mat-tab-label class="tabLabel dtableCell">
          Milestone Bonuses
        </ng-template>
        <div *ngIf="milestoneDetails.length == 0  && showNoRecord==false"> 
          <h4 class="text-center">Loading...</h4> 
        </div>
        <div class="infoMain" *ngIf="milestoneDetails.length">
          <h3 class="text-center milestoneInfo" *ngIf="milestoneMessage?.trim()" >{{milestoneMessage}}</h3>
          <div class="row">
            <div>
              <div class="col-12 s12 m6 l6 xl6 infoIndiv ">
                <h2 class="flexWrapper">
                  <span class="w-20"># Of Drafts</span>
                  <span class="w-44">Reward</span> </h2>
                <perfect-scrollbar [config]="config" style="max-width: 100%; max-height: 265px;">
                  <ul>
                    <li *ngFor="let data of milestoneDetails" class="flexWrapper ">
                      <div class="w-20">{{data.no_of_draft}}</div>
                      <div class="w-20">{{data.reward}}</div>
                    </li> 
                  </ul>
                </perfect-scrollbar>
              </div>
            </div>
            </div>
          </div> 
        <div *ngIf="milestoneDetails.length == 0 &&  showNoRecord"> 
          <h4 class="text-center">No Record Found.</h4> 
        </div> 
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label class="tabLabel dtableCell">
          <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
          <span *ngIf="infoData.hide_entrant == undefined || infoData.hide_entrant == 'N'">Entrants ({{infoData.joined_entrants | number:'1.0-0'}} of {{infoData.entrants | number:'1.0-0' }})</span>
          <span *ngIf="infoData.hide_entrant !== undefined && infoData.hide_entrant == 'Y'">Entrants ({{infoData.joined_entrants | number:'1.0-0'}})</span>
        </ng-template>
        <div class="entrantsList2" *ngIf="entrantsData">
          <mat-progress-bar style="margin: 5px;" *ngIf="loading || showprogressbar" class="loadingBar" mode="buffer"></mat-progress-bar>
          <perfect-scrollbar class=" maxHei400" [config]="config" style="max-width: 100%;"  (psYReachEnd)="onScrollEvent($event)">
            <ng-container *ngIf="this.infoData.joined_entrants>50"> 
              <div class="searchContainer" style="margin-left: 5px;">
                <mat-form-field >
                  <mat-label>Search</mat-label>
                  <input matInput placeholder="Search Entrants" (ngModelChange)="updateSearch($event)" #searchInput [ngModel]="curSearch" cdkFocusInitial>
                  <button matSuffix mat-icon-button aria-label="Close" *ngIf="curSearch!=''" (click)="updateSearch('')">
                    <mat-icon matTooltip="Close"
                    matTooltipPosition="above" >X</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </ng-container>
            <div class="entrantsBox" *ngFor="let entrant of searchEntrantsData">
              <span class="usreImg  dynamicBg" [ngStyle]="{'background-image': 'url(' +assetURL+'/'+ entrant.picture + ')'}"               >
                <div *ngIf="entrant.count>1" [matBadge]="entrant.count" matBadgePosition="above after" [matBadgeHidden]="entrant?.count <= 1"></div>
                <span class="startIcon_join" *ngIf="entrant.premium_star">
                  <i class="starhover zmdi zmdi-star" tooltip="{{entrant.premium_star_msg}}" [options]="tooltipPly"></i>
                </span>
              </span>
              <h4>{{entrant.drafters_id}}</h4>
            </div> 
            <div *ngIf="entrantsData.length == 0 && infoData.joined_entrants > 0 && showNoRecord==false"> 
              <h4 class="text-center">Loading...</h4> 
            </div>
            <div *ngIf="infoData.joined_entrants == 0 || showNoRecord"> 
              <h4 class="text-center">No Record Found.</h4> 
            </div> 
          </perfect-scrollbar>
        </div>
      </mat-tab>
      
    </mat-tab-group> 
  </div>
</div>

<!--  mobile screen  -->
<!-- <div *ngIf="isMobile">
  mobile screen tournament
</div> -->
